import { Component, Input, Output, ChangeDetectionStrategy, EventEmitter, OnChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

export interface GridLegendItem {
    icon?: string;
    text?: string;
    cssClass?: string | string [];
    label: string;
}

@Component({
    selector: 'grid-legend',
    template: require('./grid-legend.component.html'),
    styles: [require('./grid-legend.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridLegendComponent {

    @Input()
    public items: GridLegendItem[] = [];
}